/**
 * @Description: 项目常量
 * @Author: Diviner
 * @Date: 2021-09-28 20:33:36
 **/

// 关系集合
export var relationMap = [{
  text: "父亲",
  value: 1
}, {
  text: "母亲",
  value: 2
}, {
  text: "爷爷",
  value: 3
}, {
  text: "奶奶",
  value: 4
}, {
  text: "外公",
  value: 5
}, {
  text: "外婆",
  value: 6
}, {
  text: "亲戚",
  value: 7
}, {
  text: "其他",
  value: 8
}];

// 是否就诊集合
export var realMap = [{
  text: "是",
  value: 1
}, {
  text: "否",
  value: 0
}];

// 请假原因集合
export var reasonMap = [{
  text: "无",
  value: 1
}, {
  text: "因病请假",
  value: 2
}, {
  text: "因伤害请假",
  value: 3
}, {
  text: "因事请假",
  value: 4
}, {
  text: "其他",
  value: 5
}];

// 症状表现集合
export var symptomMap = [{
  name: "无",
  value: 1
}, {
  name: "发热",
  value: 2
}, {
  name: "咳嗽",
  value: 3
}, {
  name: "乏力",
  value: 4
}, {
  name: "咽痛",
  value: 5
}, {
  name: "腹痛",
  value: 6
}, {
  name: "头痛",
  value: 7
}, {
  name: "腮腺肿大",
  value: 8
}, {
  name: "鼻塞",
  value: 9
}, {
  name: "流涕",
  value: 10
}, {
  name: "盗汗",
  value: 11
}, {
  name: "腹泻",
  value: 12
}, {
  name: "呕吐",
  value: 13
}, {
  name: "皮疹",
  value: 14
}, {
  name: "结膜红肿",
  value: 15
}, {
  name: "黄疸",
  value: 16
}, {
  name: "肌肉酸痛",
  value: 17
}, {
  name: "关节痛",
  value: 18
}, {
  name: "其他",
  value: 19
}];
110115210;
110115209;
110115208;
110115207;
110115206;
110115205;
110115204;
110115203;
110115202;
110115201;
110115200;
110115199;
110115198;
110115197;
110115196;
110115195;
110115194;
110115193;
110115192;
110115191;
110115190;

// 近视干预学校集合
export var schoolMap = [
//测试
{
  name: "平遥县小学",
  username: "140728136"
},
//正式
{
  name: "北京印刷学院附属小学",
  username: "110115210"
}, {
  name: "北京小学翡翠城分校",
  username: "110115209"
}, {
  name: "北京市大兴区金海学校",
  username: "110115208"
}, {
  name: "北京石油化工学院附属小学",
  username: "110115207"
}, {
  name: "首都师范大学附属中学大兴南校区",
  username: "110115206"
}, {
  name: "北京市育才学校大兴分校",
  username: "110115205"
}, {
  name: "北京市海淀区五一小学大兴一分校",
  username: "110115204"
}, {
  name: "北京市海淀区五一小学大兴二分校",
  username: "110115203"
}, {
  name: "北京市大兴区永华实验学校",
  username: "110115202"
}, {
  name: "北京市大兴区兴华中学(仰山)",
  username: "110115201"
}, {
  name: "庞各庄镇第一中心小学",
  username: "110115200"
}, {
  name: "北京市大兴区魏善庄镇第二中心小学",
  username: "110115199"
}, {
  name: "北京市大兴区实验小学",
  username: "110115198"
}, {
  name: "北京市大兴区第九小学",
  username: "110115197"
}, {
  name: "北京市大兴区第二中学(东校区)",
  username: "110115196"
}, {
  name: "北京市大兴区第八小学",
  username: "110115195"
}, {
  name: "北京市大兴区采育镇第一中心小学",
  username: "110115194"
}, {
  name: "北京教育学院附属大兴实验小学",
  username: "110115193"
}, {
  name: "庞各庄镇第一中心小学",
  username: "110115192"
}, {
  name: "海淀区翠微小学大兴分校",
  username: "110115191"
}, {
  name: "礼贤镇第二中心小学",
  username: "110115190"
}];